export default __webpack_public_path__ + "static/media/bank-icon.634cb2d7.svg";